import * as React from 'react';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Chip from '@material-ui/core/Chip';
import { createStyles, makeStyles, useTheme, Theme } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import { SectionFieldContainerProps, SectionFieldOption } from '../typings';

function getStyles(currentValue: string, multiValueArr: string[], theme: Theme) {
  if (multiValueArr.indexOf(currentValue) !== -1) {
    return {
      fontWeight: 500,
      backgroundColor: '#D4E0EE',
      color: theme.palette.primary.main
    };
  }
  return {};
}

const MultipleSelect: React.FC<SectionFieldContainerProps> = (multiSelectProps) => {
  const useStyles = makeStyles(() =>
    createStyles({
      chips: {
        display: 'flex',
        flexWrap: 'wrap'
      },
      chip: {
        margin: 4
      },
      button: {
        margin: 4
      },
      root: {
        zIndex: 0,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        maxWidth: '80%',
        height: '100%'
      }
    })
  );
  const classes = useStyles();
  const theme = useTheme();
  const [multiSelectValue, setMultiSelectValue] = React.useState<string[]>([]);
  const { isMobile, sectionFieldDetails } = multiSelectProps;
  const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    setMultiSelectValue(event.target.value as string[]);
  };

  return (
    <FormControl variant='outlined' fullWidth size={isMobile ? 'small' : 'medium'}>
      <InputLabel classes={{ root: classes.root }} id='multi-select-outlined-label'>
        {sectionFieldDetails.name}
      </InputLabel>
      <Select
        labelId='multi-select-outlined-label'
        label={sectionFieldDetails.name}
        multiple
        value={multiSelectValue}
        onChange={handleChange}
        renderValue={(selected) => (
          <div className={classes.chips}>
            {(selected as string[]).map((value, i) => (
              // eslint-disable-next-line react/no-array-index-key
              <div key={value + i}>
                {multiSelectProps.isMobile && <Chip key={value} label={value} className={classes.chip} />}
                {!multiSelectProps.isMobile && (
                  <Button className={classes.button} variant='contained' color='default' key={value}>
                    {value}
                  </Button>
                )}
              </div>
            ))}
          </div>
        )}
        MenuProps={{
          getContentAnchorEl: () => null as any
        }}
      >
        {sectionFieldDetails.selectOptions?.map((eachOption: SectionFieldOption) => (
          <MenuItem key={eachOption.name} value={eachOption.name} style={getStyles(eachOption.name, multiSelectValue, theme)}>
            {eachOption.name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default MultipleSelect;
